import React from "react";
import { useUserQuestStats } from "@/hooks/useUserQuestStats";
import styles from "./ActionCards.module.scss";

interface TodayQuestProgressCardProps {
    activeQuests?: any[];
    overallProgress?: number;
}

const TodayQuestProgressCard: React.FC<TodayQuestProgressCardProps> = () => {
    const { summary, quests } = useUserQuestStats();

    // Filter for daily quests that are in progress
    const dailyQuests = quests.filter(q =>
        q.type === "daily" &&
    !q.isClaimed &&
    q.progress > 0);

    // Get the most progressed daily quest or use overall progress
    const topQuest = dailyQuests.sort((a, b) => b.percentComplete - a.percentComplete)[0];

    const handleContinue = () => {
    // Scroll to quest table
        const questTable = document.querySelector(".quest-table");
        questTable?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <div
            className="stat-card"
            onClick={handleContinue}
            style={{
                cursor: "pointer",
                backgroundImage: "url(/images/card-bck7.png)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                border: "1px solid rgba(76, 175, 80, 0.3)",
                boxShadow: "inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 4px 12px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(76, 175, 80, 0.15)",
                position: "relative",
            }}
        >
            <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.4)",
                borderRadius: "inherit",
            }}></div>
            <div style={{ position: "relative", zIndex: 1 }}>
                <h4 style={{ color: "white", textShadow: "0 2px 4px rgba(0, 0, 0, 0.8)" }}>🎯 DAILY QUESTS</h4>
                <div className="stat-value" style={{ color: "#4CAF50", textShadow: "0 2px 4px rgba(0, 0, 0, 0.8)", fontWeight: "600" }}>
                    {summary.activeCount > 0 ? `${Math.round(summary.overallProgress)}%` : "0/0"}
                </div>
                <div className="stat-subtitle" style={{ color: "rgba(255, 255, 255, 0.9)", textShadow: "0 1px 2px rgba(0, 0, 0, 0.8)" }}>
                    {summary.activeCount > 0 ? `${summary.activeCount} Active` : "Start Playing"}
                </div>
            </div>
        </div>
    );
};

export default TodayQuestProgressCard;